import { router } from 'expo-router';

import type { Command } from './types';

export const newQuoteCommand: Command = {
	id: 'new-quote',
	title: 'New Quote',
	description: 'Create a new quote',
	icon: 'receipt-outline',
	category: 'create',
	keywords: ['quote', 'estimate', 'price', 'cost'],
	action: (closeSearch) => {
		router.push('/quotes/new');
		closeSearch?.();
	},
};
